module.exports = __webpack_public_path__ + "img/9788972883548.12731c8b.jpg";